var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOutside = function SvgOutside(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14H2V2h4a1 1 0 0 0 0-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4a1 1 0 0 0-2 0v4Zm0-10.6V6a1 1 0 0 0 2 0V2a2 2 0 0 0-2-2h-4a1 1 0 0 0 0 2h2.565l-5.27 5.27a1 1 0 0 0 0 1.41 1 1 0 0 0 1.43 0L14 3.4Z"
  })));
};
export default SvgOutside;